module.exports = __webpack_public_path__ + "static/media/logo@2x.27f8de6e.png";